<template>
  <div class="editing-record-timeline">
    <!-- Inga editingRecords meddelande -->
    <template v-if="!loading && editingRecords.length === 0">
      <div class="d-flex flex-column full-width">
        <div class="mx-auto mt-6">
          <v-icon large>mdi-ghost-outline</v-icon>
        </div>
        <p class="text-caption-2 text--secondary my-auto mx-auto py-6">
          Här var det tomt
        </p>
      </div>
    </template>

    <v-timeline
      v-else
      dense
      class="overflow-hidden pt-0"
      align-top
    >
      <template v-if="loading">
        <!-- Skeleton loaders -->
        <v-timeline-item
          v-for="n in 3"
          :key="n"
          fill-dot
          class="skeleton-loaders-timeline-item"
        >
          <template v-slot:icon>
            <v-skeleton-loader type="avatar"></v-skeleton-loader>
          </template>
          <div class="pt-1">
            <v-skeleton-loader type="text" width="60%" class="mb-1"></v-skeleton-loader>
            <v-skeleton-loader type="text" width="85%"></v-skeleton-loader>
          </div>
        </v-timeline-item>
      </template>

      <template v-else>
        <!-- editingRecords -->
        <div
          v-for="timeGroups in editingRecords"
          :key="timeGroups.date"
        >
          <v-timeline-item
            class="pb-1 pt-2"
            fill-dot
            hide-dot
            color="primary date-timeline-item"
          >
            <template v-slot:icon>
              <v-icon small color="white">mdi-calendar</v-icon>
            </template>
            <div class="text-subtitle-2 font-weight-medium">
              {{ toHumanReadableDate(timeGroups.date) }}
              <span v-show="isBeforeYesterday(timeGroups.date)" class="text-caption ml-2 text-sm">({{ timeAgo(timeGroups.date) }})</span>
            </div>
          </v-timeline-item>

          <v-timeline-item
            v-for="editingRecordGroup in timeGroups.editing_record_groups"
            :key="`editingRecordGroup.key.${editingRecordGroup.time}.${editingRecordGroup.source}.${editingRecordGroup.user?.id}`"
            fill-dot
            small
            color="secondary"
            class="editing-group-timeline-item"
          >
            <template v-slot:icon>
              <v-icon x-small color="white" class="">mdi-calendar-clock</v-icon>
            </template>
            <div class="record-group-card">
              <div class="record-group-header d-flex align-center">
                <span class="text-caption font-weight-medium">{{ editingRecordGroup.time }}</span>
                <v-spacer></v-spacer>
                <template v-if="editingRecordGroup.source === 'user'">
                  <simple-tooltip tooltip="Genomfördes av inloggad användare">
                    <v-chip
                      x-small
                      outlined
                      color="primary"
                      class="record-source-chip"
                    >
                      <v-icon x-small left>
                        {{ editingRecordGroup.user?.is_support ? 'coi-campingonline' : 'mdi-account-circle' }}
                      </v-icon>
                      {{ editingRecordGroup.user?.name ?? 'Okänd användare' }}
                    </v-chip>
                  </simple-tooltip>
                </template>
                <template v-if="editingRecordGroup.source === 'system'">
                  <simple-tooltip tooltip="Genomfördes av systemet automatiskt">
                    <v-chip
                      x-small
                      outlined
                      color="primary"
                      class="record-source-chip"
                    >
                      <v-icon x-small left>coi-campingonline</v-icon>
                      CampingOnline
                    </v-chip>
                  </simple-tooltip>
                </template>
                <template v-if="editingRecordGroup.source === 'guest'">
                  <simple-tooltip tooltip="Genomfördes av gästen själv">
                    <v-chip
                      x-small
                      outlined
                      color="primary"
                      class="record-source-chip"
                    >
                      <v-icon x-small left>mdi-account</v-icon>
                      Gäst
                    </v-chip>
                  </simple-tooltip>
                </template>
              </div>
              <div
                v-for="editingRecord in editingRecordGroup.editing_records"
                :key="editingRecord.id"
                class="record-item"
              >
                <!-- Vad ändringen gäller när historiken samlar flera saker, t.ex. reservationerna i en reservationsorder -->
                <div v-if="editingRecord.subject" class="text-caption text--secondary">{{ editingRecord.subject }}</div>
                <div class="record-description" v-html="editingRecord.description"></div>
              </div>
            </div>
          </v-timeline-item>
        </div>
      </template>

      <slot name="timeline-actions"></slot>

    </v-timeline>
  </div>
</template>

<script>
import SimpleTooltip from '@/components/common/SimpleTooltip.vue'

export default {
  name: 'EditingRecordTimeline',
  components: {
    SimpleTooltip
  },
  props: {
    editingRecords: {
      type: Array,
      default: () => []
    },
    loading: Boolean
  },
  data: () => ({}),
  computed: {
    isMobile: function () {
      return this.$vuetify.breakpoint.mdAndDown
    }
  },
  methods: {
    toHumanReadableDate: function (dt) {
      return window.dayjs.parseServerDate(dt).toHumanReadableDate({ longFormat: true })
    },
    timeAgo: function (dt) {
      return window.dayjs.parseServerDate(dt).from(window.dayjs.today()) // Använd inte fromNow, vill jämföra med början av dagen eftersom det är datum utan tid
    },
    isBeforeYesterday: function (dt) {
      return window.dayjs.parseServerDate(dt).isBefore(window.dayjs.yesterday())
    }
  },
  watch: {}
}
</script>
